import { ViewIcon, EditIcon, DeleteIcon, CheckIcon, CloseIcon } from '@chakra-ui/icons';

export const columnsDataClients = [
  {
    Header: "Nombre",
    accessor: "name",
  },
  {
    Header: "Documento",
    accessor: "document",
  },
  {
    Header: "Teléfono",
    accessor: "phone",
  },
  {
    Header: "Ciudad",
    accessor: "location",
    cell: (info) => {
      const customer = info.row.original;
      const locality = customer.locality?.name || '';
      return locality || 'No disponible';
    }
  },
  {
    Header: "Cliente Habitual",
    accessor: "regularCustomer",
    cell: (info) => {
      const isRegular = info.getValue();
      return isRegular ? <CheckIcon color="green.500" /> : <CloseIcon color="red.500" />;
    }
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
      {
        label: 'Ver',
        icon: <ViewIcon />,
        colorScheme: 'blue',
        type: 'view'
      },
      {
        label: 'Eliminar',
        icon: <DeleteIcon />,
        colorScheme: 'red',
        type: 'delete'
      }
    ]
  }
];
